import {get as _get, set as _set} from '@servicenow/ui-internal';
import {assign as _assign} from './assign';
import {merge as _merge} from './merge';

function operateAtPath(operationFn, obj, path, value) {
	if (!path) return operationFn(obj, value);

	const location = _get(obj, path);
	if (location === undefined || typeof location !== 'object') return _set(obj, path, value);

	return operationFn(location, value);
}

// Object
export const set = (obj, {path, value}) => _set(obj, path, value);
export const assign = (obj, {path, value}) => operateAtPath(_assign, obj, path, value);
export const merge = (obj, {path, value}) => operateAtPath(_merge, obj, path, value);

// Array
export const pop = (obj, {path}) => _get(obj, path).pop();
export const push = (obj, {path, value}) => _get(obj, path).push(value);
export const shift = (obj, {path}) => _get(obj, path).shift();
export const unshift = (obj, {path, value}) => _get(obj, path).unshift(value);
export const splice = (obj, {path, start = 0, deleteCount = 0, addItems = []}) =>
	_get(obj, path).splice(start, deleteCount, ...addItems);
export const concat = (obj, {path, value}) => {
	const arr = _get(obj, path);
	return arr.push.apply(arr, value); // eslint-disable-line prefer-spread
};

export const declarativeOperations = {
	SET: 'set',
	ASSIGN: 'assign',
	MERGE: 'merge',
	POP: 'pop',
	PUSH: 'push',
	SHIFT: 'shift',
	UNSHIFT: 'unshift',
	SPLICE: 'splice',
	CONCAT: 'concat'
};

// TODO: Map / Set / Date
